/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import InfoSquare from './info-square-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <InfoSquare {...validProps} />;
}
SvgComponent.iconName = 'info-square-icon';

export const InfoSquareIcon = svgIconWrapper(SvgComponent);
